export default __webpack_public_path__ + "static/media/student-ease-logo.7748eed4.png";